import { useState } from "react";

import { searchWord } from "../../_helpers/search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useProduct } from "../../services/products/product.context";


export const UpdateSearchForm = ({ onSearch, handleCancel }) => {

    const [isTyping, setIsTyping] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [inventory, setInventory] = useState([]);

    const { getProductsByBatch } = useProduct();

    const itemList = () => {
        const productNames = inventory.map((product) => product?.designation);
        const productBrands = inventory.map((product) => product.brand);

        const res = [...productBrands, ...productNames];

        return [...new Set(res)];
    }

    const handleSearch = (v) => {
        onSearch(v)
    }

    const handleInput = (v) => {
        setIsTyping(true);
        const wordList = itemList();
        const searchRes = searchWord(v.target.value, wordList);
        setSearchResult(searchRes);
        (async () => {
            const resp = await getProductsByBatch();
            setInventory(resp?.data);
        })();
        if (!v.target.value && !v.inputType) {
           handleCancel();
        }
    }

    return (
        <div style={{ width: '100vw' }}>
            <form
                className="search-form"
                onSubmit={(e) => {
                    e.preventDefault();
                }}
            >
                <FontAwesomeIcon className="s-icon" icon={faSearch} />
                {searchResult.length > 0 && <span className="s-txt">Search </span>}
                <input
                    type="search"
                    name="keyword"
                    className="search-input"
                    onChange={(e) => handleInput(e)}
                    onBlur={() => setIsTyping(false)}
                    placeholder="Search Brand/Category/device"
                />

            </form>
            {searchResult.length > 0 && (
                <div className="search-result">
                    {searchResult.map((result, i) => (
                        <button
                            key={i}
                            className="search-touch"
                            onClick={() => handleSearch(result)}
                        >
                            {result}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}